var map = {
	"./1.jpg": "tlO+",
	"./2.jpg": "kWol",
	"./3.jpg": "5QgY",
	"./4.jpg": "uTXZ",
	"./5.jpg": "eItn",
	"./6.jpg": "vYtI",
	"./7.jpg": "I0zW",
	"./8.jpg": "KeGu",
	"./9.jpg": "ZFfe"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KWXB";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kite-surf ^\.\/.*\.jpg$
// module id = KWXB
// module chunks = 1